import React, { useState, useEffect } from 'react';
import globalSettingsBranches from '../../../../stores/global-settings-branches';
import { SettingsBranches } from '../../../../api/types/settings/branches/settings-branches';
import dateUtils from '../../../../utils/date-format';
import { createNewBranchOperation } from './operations/create-new-branch-operation';
import { Dialog } from 'primereact/dialog';
import { AddBranchDialog } from './components/add-branch-dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import './settings-branches-tab.css';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import appApi from '../../../../api/app-api';
import { updateEntityNameOperation } from '../../operations/update-entity-name/update-entity-name-operation';
import { SettingsEntityType } from '../../operations/update-entity-name/settings-entity-types';
import { EditTextDialog } from '../../componenets/edit-entity-name-dialog/edit-text-dialog';
import { deleteBranchOperation } from './operations/delete-branch-operation';
import { Toast } from 'primereact/toast';
import { BuildingListDialog } from './components/building-list-dialog';
import { Building } from '../../../../api/types/settings/buildings/building';
import { addBuildingToBranchOperations } from './operations/add-building-to-branch-operations';

const SettingsBranchesTab = observer(() => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [newBranchName, setNewBranchName] = useState('');
  const [showDialog, setShowDialog] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState<SettingsBranches | null>(
    null,
  );
  const [editBranch, setEditBranch] = useState<SettingsBranches | null>(null);
  const [deleteBranchId, setDeleteBranchId] = useState<number | null>(null);
  const [showBuildingDialog, setShowBuildingDialog] = useState(false);
  const [selectedBuildings, setSelectedBuildings] = useState<Building>([]);
  const [currentBranchForBuildings, setCurrentBranchForBuildings] =
    useState<SettingsBranches | null>(null);
  const toast = React.useRef<Toast>(null);

  useEffect(() => {
    const initializeData = async () => {
      setIsLoading(true);
      try {
        if (globalSettingsBranches.branches.length === 0) {
          const branchesData = await appApi.getBranches();
          globalSettingsBranches.branches = branchesData;
        }
        globalSettingsBranches.handleNavigationToBranches();
      } catch (error) {
        console.error('Error fetching branches:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeData();
  }, []);

  const onSubmit = async () => {
    await createNewBranchOperation(newBranchName, setIsLoading, () => {
      setNewBranchName('');
    });
  };

  const dialogHide = () => {
    setShowDialog(false);
  };
  const dialogDisplay = () => {
    setShowDialog(true);
  };

  const handleEditBranch = (branch: SettingsBranches) => {
    setEditBranch(branch);
  };

  const handleSaveBranch = async (id: number, newName: string) => {
    await updateEntityNameOperation(
      SettingsEntityType.BRANCH,
      id,
      newName,
      setIsLoading,
    );
  };

  const handleDeleteBranch = async (branchId: number) => {
    await deleteBranchOperation(branchId, setDeleteBranchId);
  };

  const onRowSelect = (event: { value: SettingsBranches }) => {
    const branchIndex = globalSettingsBranches.branches.findIndex(
      (branch) => branch.id === event.value.id,
    );
    if (branchIndex !== -1) {
      globalSettingsBranches.currentBranchIndex = branchIndex;
      navigate(
        `/settings/branch-and-classes/branches/${event.value.id}/buildings`,
      );
    }
  };

  const handleAddBuildings = (branch: SettingsBranches) => {
    setCurrentBranchForBuildings(branch);
    setShowBuildingDialog(true);
  };

  const handleBuildingDialogHide = () => {
    setShowBuildingDialog(false);
    setSelectedBuildings([]);
    setCurrentBranchForBuildings(null);
  };

  const handleBuildingSelection = async () => {
    //const buildingIds = selectedBuildings.map((building) => building.id);
    const buildingIds = selectedBuildings.id;
    await addBuildingToBranchOperations(
      currentBranchForBuildings?.id,
      buildingIds,
    );
    handleBuildingDialogHide();
  };

  const getAllBuildings = () => {
    const buildingsMap = new Map();
    globalSettingsBranches.branches.forEach((branch) => {
      if (branch.buildings && Array.isArray(branch.buildings)) {
        branch.buildings.forEach((building) => {
          if (
            building &&
            building.id &&
            building.buildingName &&
            typeof building === 'object'
          ) {
            buildingsMap.set(building.id, building);
          }
        });
      }
    });
    return Array.from(globalSettingsBranches.buildings);
  };

  return (
    <div>
      <Toast ref={toast} />
      <Button
        style={{ height: '30px', marginBottom: '16px' }}
        label={'הוספת שלוחה'}
        onClick={dialogDisplay}
      />

      <DataTable
        value={globalSettingsBranches.branches}
        loading={isLoading}
        rows={10}
        selectionMode="single"
        onSelectionChange={(e) => onRowSelect(e)}
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        className="p-datatable-striped"
      >
        <Column
          style={{ textAlign: 'right' }}
          field="branchName"
          header="שם"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          header="מבנים"
          body={(rowData: SettingsBranches) =>
            rowData.buildings
              .map((building) => building.buildingName)
              .join(', ')
          }
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="תאריך יצירה"
          sortable
          body={(rowData: SettingsBranches) =>
            dateUtils.displayFormatDate(new Date(rowData.createdAt))
          }
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdByName"
          header="נוצר ע״י"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: SettingsBranches) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-plus"
                text
                tooltip={'הוסף מבנה'}
                onClick={() => handleAddBuildings(data)}
              />
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת שלוחה'}
                onClick={() => handleEditBranch(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת שלוחה'}
                loading={deleteBranchId === data.id}
                disabled={deleteBranchId !== null}
                onClick={() => handleDeleteBranch(data.id)}
              />
            </div>
          )}
        />
      </DataTable>

      <Dialog
        header="הוספת שלוחה"
        visible={showDialog}
        onHide={dialogHide}
        style={{
          width: '500px',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
      >
        <AddBranchDialog closeDialog={dialogHide} />
      </Dialog>

      <EditTextDialog
        id={editBranch?.id}
        value={editBranch?.branchName}
        title="עריכת שלוחה"
        label="שם השלוחה"
        loading={isLoading}
        onSave={handleSaveBranch}
        onHide={() => setEditBranch(null)}
      />

      <BuildingListDialog
        visible={showBuildingDialog}
        onHide={handleBuildingDialogHide}
        buildings={getAllBuildings()}
        selectedBuildings={selectedBuildings}
        onSelectionChange={setSelectedBuildings}
        onConfirm={handleBuildingSelection}
      />
    </div>
  );
});

export default SettingsBranchesTab;
